import { useState, useEffect, useContext } from 'react';
import Header from 'widgets/header';
import { Input } from '@acko-tech/building-blocks.ui.input';
import { PrimaryButton } from '@acko-tech/building-blocks.ui.button';
// import Checkbox from 'library/checkbox';
import { useSegmentViewEvents } from 'hooks/useSegmentView';
import { useResponsiveDevice } from 'hooks/useResponsiveDevice';
import {
    SegmentEventNameTypes,
    SegmentEventPageTypes,
    SegmentEventPages,
    PRODUCT,
    SUB_PRODUCT_NAME,
} from 'utils/segment/constants';
import { MPosContext } from 'utils/context';
import { useRouter } from 'next/router';
import { IOrderDetails } from './types';
import ErrorPage from 'widgets/errorScreen';
import { getPlanName, whatsCoverText } from 'utils/generics';
import SnackBar from 'library/snackbar';
import { dealerPayment } from 'utils/api/services';
import * as Styles from './styles';

function Payment() {
    const router = useRouter();
    const { order_ekey } = router.query;

    const { partnerId } = useContext(MPosContext);

    const [orderDetails, setOrderDetails] = useState<IOrderDetails | null>(
        null
    );
    const [isLoading, setIsLoading] = useState(true);
    // const [isCheckboxSelected, setIsCheckboxSelected] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const [snackbar, setSnackbar] = useState({
        type: '',
        message: '',
    });
    const [isBtnLoading, setIsBtnLoading] = useState(false);
    const { isMobile } = useResponsiveDevice();

    /**
     * view segment hook
     */

    useSegmentViewEvents(SegmentEventNameTypes.VIEW, {
        page_url: typeof window !== 'undefined' ? window.location.href : '',
        page_type: SegmentEventPageTypes.MAIN_PAGE,
        view_name: SegmentEventPages.VIEW_PAYMENT_PAGE,
        product: PRODUCT,
        sub_product_name: SUB_PRODUCT_NAME,
        platform: isMobile ? 'mweb' : 'web',
        referrer: document.referrer || '',
        device: navigator.userAgent || '',
        partner: partnerId,
    });

    useEffect(() => {
        import('./apis').then(async (req) => {
            const { status, data, statusCode } =
                await req.getCustomerPlanDetails(partnerId, order_ekey);
            if (statusCode === 401) {
                router.push('/login');
                setSnackbar({
                    type: 'failure',
                    message: 'Token expired. Redirecting to login page.',
                });
                return;
            }
            setIsLoading(false);
            if (status && data?.recent_orders?.length > 0) {
                setOrderDetails(data.recent_orders[0]);
                setErrorMessage('');
            } else {
                setErrorMessage('Oops. something went wrong.');
            }
        });
    }, []);

    const onPayNow = () => {
        setIsBtnLoading(true);
        dealerPayment(partnerId, order_ekey).then(
            ({ data, status, statusCode }) => {
                setIsBtnLoading(false);
                if (statusCode === 401) {
                    router.push('/login');
                    setSnackbar({
                        type: 'failure',
                        message: 'Token expired. Redirecting to login page.',
                    });
                    return;
                }
                if (status && data) {
                    if (status && data?.payment_gateway_url) {
                        window.location.href = `${data.payment_gateway_url}?id=${data?.payment_order_ekey}&redirect_source=pos_dealer`;
                    }
                    return;
                }
                setSnackbar({
                    type: 'failure',
                    message: 'Oops. Something went wrong.',
                });
            }
        );
    };

    // const onClickTnc = () => {
    //     window.open(getTncLink(), '_blank');
    // };

    if (isLoading) {
        return <></>;
    }

    if (errorMessage) {
        return <ErrorPage />;
    }

    return (
        <Styles.Wrapper>
            <Styles.HeaderWrapper>
                <Header />
            </Styles.HeaderWrapper>
            <Styles.CustomPlanDetailsWrapper>
                <Styles.HeaderTitle>
                    Confirm and pay for your customer
                </Styles.HeaderTitle>
                <Styles.PlanDetailsWrapper>
                    <Styles.RowWrapper>
                        <Styles.LabelText>Device model</Styles.LabelText>
                        <Styles.ValueText>
                            {orderDetails?.device.name}
                        </Styles.ValueText>
                    </Styles.RowWrapper>
                    <Styles.Hr />
                    <Styles.RowWrapper>
                        <Styles.LabelText>Serial number</Styles.LabelText>
                        <Styles.ValueText>
                            {orderDetails?.device.serial_number}
                        </Styles.ValueText>
                    </Styles.RowWrapper>
                    <Styles.Hr />
                    <Styles.RowWrapper>
                        <Styles.LabelText>Plan Name</Styles.LabelText>
                        <Styles.ValueText>
                            {getPlanName(orderDetails?.plan.plan_name || '')}
                        </Styles.ValueText>
                    </Styles.RowWrapper>
                    <Styles.Hr />
                    <Styles.RowWrapper>
                        <Styles.LabelText>What’s covered</Styles.LabelText>
                        <Styles.ValueText>
                            {whatsCoverText(
                                orderDetails?.plan?.plan_category?.toLowerCase() ||
                                    orderDetails?.plan?.plan_id?.toLowerCase() ||
                                    ''
                            )}
                        </Styles.ValueText>
                    </Styles.RowWrapper>
                </Styles.PlanDetailsWrapper>
            </Styles.CustomPlanDetailsWrapper>
            <Styles.CustomerDetailsFormWrapper>
                <Styles.FormTitle>
                    {`Please find your customer's details`}
                </Styles.FormTitle>
                <Styles.InputWrapper>
                    <Input
                        name={'name'}
                        type={'text'}
                        className={''}
                        value={orderDetails?.customer.name || ''}
                        onChange={() => {}}
                        labelText={'Full name'}
                        disabled={true}
                    />
                </Styles.InputWrapper>
                <Styles.InputWrapper>
                    <Input
                        name={'email'}
                        type={'text'}
                        className={''}
                        value={orderDetails?.customer?.email || ''}
                        onChange={() => {}}
                        labelText={'Email address'}
                        disabled={true}
                    />
                </Styles.InputWrapper>
                <Styles.InputWrapper>
                    <Input
                        name={'mobile'}
                        type={'text'}
                        className={''}
                        value={orderDetails?.customer.phone || ''}
                        onChange={() => {}}
                        labelText={'Mobile number'}
                        disabled={true}
                    />
                </Styles.InputWrapper>
                {/* <Styles.TncWrapper>
                    <Styles.CheckboxFlex>
                        <Checkbox
                            isSelected={isCheckboxSelected}
                            onSelectHandler={() => {
                                setIsCheckboxSelected((s) => !s);
                            }}
                            color={'#0FA457'}
                        />
                    </Styles.CheckboxFlex>
                     <Styles.TncText>
                        I agree to the Terms and conditions
                        <span
                            style={{ color: '#1B73E8', marginLeft: '5px' }}
                            onClick={onClickTnc}
                        >
                            {' '}
                            Terms and conditions
                        </span>
                    </Styles.TncText>
                </Styles.TncWrapper> */}
            </Styles.CustomerDetailsFormWrapper>
            <Styles.Hr1 />
            <Styles.PriceDetailsFlex>
                <Styles.Price>₹{orderDetails?.plan.premium}</Styles.Price>
                <Styles.Tax>(incl 18% GST)</Styles.Tax>
                <Styles.PayNowButton>
                    <PrimaryButton
                        loading={isBtnLoading}
                        size={'small'}
                        // disabled={!isCheckboxSelected}
                        onClick={onPayNow}
                    >
                        Pay now
                    </PrimaryButton>
                </Styles.PayNowButton>
            </Styles.PriceDetailsFlex>
            <SnackBar
                {...snackbar}
                handleSnakbarComplete={() =>
                    setSnackbar({ type: '', message: '' })
                }
            />
        </Styles.Wrapper>
    );
}

export default Payment;
